import { DatePipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { CommonHeaderComponentModule } from '../../components/common-header/common-header.module';
import { StateFooterComponentModule } from '../../components/state-footer/state-footer.module';
import { ADViewPage } from './ad-view';
import { HalfDayBlockComponentModule } from '../../components/halfday-block/halfday-block.module';
 
@NgModule({
  declarations: [
    ADViewPage,
  ],
  imports: [
    CommonHeaderComponentModule,
    HalfDayBlockComponentModule,
    StateFooterComponentModule,
    IonicPageModule.forChild(ADViewPage),
  ],
  exports: [
    ADViewPage
  ],
  providers:[
      DatePipe
  ]
})
export class ADViewModule {

}


// WEBPACK FOOTER //
// ./src/pages/ad-view/ad-view.module.ts